import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'button-approvers',
  templateUrl: './button-approvers.component.html',
  styleUrls: ['./button-approvers.component.scss']
})
export class ButtonApprovers implements OnInit {
  @Output() eventClick = new EventEmitter<any>();

  constructor() { 
    //This is intentional.
  }

  ngOnInit(): void {
    //This is intentional.
  }

  viewDetails() {
    this.eventClick.emit();
  }
}
